import { render, staticRenderFns } from "./BankAccountsWidget.vue?vue&type=template&id=27d5d798&scoped=true"
import script from "./BankAccountsWidget.vue?vue&type=script&lang=js"
export * from "./BankAccountsWidget.vue?vue&type=script&lang=js"
import style0 from "./BankAccountsWidget.vue?vue&type=style&index=0&id=27d5d798&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d5d798",
  null
  
)

export default component.exports